import { Component, ViewChild } from '@angular/core';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { ModalPurchaseOrderComponent } from 'src/app/components/inventory-modals/modal-purchase-order.component';
import { PurchaseOrder } from 'src/app/models/purchase-order';
import { InventoryService } from 'src/app/services/inventory.service';
import { IconsService } from 'src/app/shared/services/icons.service';

@Component({
  selector: 'app-index-purchase-order',
  template: `
    <div class="d-flex mb-4 mt-4">
      <div>
        <h1>Compras</h1>
        <xng-breadcrumb ></xng-breadcrumb>
      </div>
    </div>
  <div class="d-flex">
    <div class="me-3" style="width: 222px !important; min-width: 222px !important;">
      <ul #subnav app-nav-inventory [currentView]="currentView" class="sidebar-zazz list-unstyled"></ul>
    </div>
    <div #pages class="flex-fill">
      <div class="d-flex mt-1">
        <div class="flex-fill">
          <div class="d-flex mb-3">
            <h3>Ordenes de compra</h3>
          </div>
          <div class="d-flex">          
            <div>
              <div ngbDropdown class="d-inline-block" (click)="datepicker.toggle()">
                <button type="button" class="btn btn-zazz-default rounded-4 px-4 shadow-sm" id="dropdownForm1" ngbDropdownToggle>
                  <fa-icon [icon]="icons.faCalendarAlt" class="me-2"></fa-icon>
                  Este mes
                </button>
                <div ngbDropdownMenu aria-labelledby="dropdownForm1" class="shadow" style="width: 650px;">
                  <div class="row">
                    <div class="col-3">
                      <ul class="list-group calendar-list-group ps-2 mt-2">
                        <li class="list-group-item list-group-item-action active">Hoy</li>
                        <li class="list-group-item list-group-item-action">Ayer</li>
                        <li class="list-group-item list-group-item-action">Este mes</li>
                        <li class="list-group-item list-group-item-action">Últimos 7 días</li>
                        <li class="list-group-item list-group-item-action">Últimos 30 días</li>
                        <li class="list-group-item list-group-item-action">Personalizado</li>
                      </ul>
                    </div>
                    <div class="col-9" style="height: 320px;">
                      <div class="input-group">
                        <input
                          #dpFromDate
                          class="form-control"
                          style="width: 0px !important; height: 0px !important; opacity: 0;"
                          ngbDatepicker
                          #datepicker="ngbDatepicker"
                          [autoClose]="'outside'"
                          (dateSelect)="onDateSelection($event)"
                          [displayMonths]="2"
                          [dayTemplate]="t"
                          outsideDays="hidden"
                          [startDate]="fromDate!"
                          tabindex="-1" 
                        />
                        <ng-template #t let-date let-focused="focused">
                          <span
                            class="custom-day"
                            [class.focused]="focused"
                            [class.range]="isRange(date)"
                            [class.faded]="isHovered(date) || isInside(date)"
                            (mouseenter)="hoveredDate = date"
                            (mouseleave)="hoveredDate = null"
                          >
                            {{ date.day }}
                          </span>
                        </ng-template>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="dropdown-divider"></div>
                      <div class="d-flex text-end flex-fill flex-row-reverse me-2">
                        <button type="button" class="btn btn-zazz-dark ms-2 rounded-4 shadow-sm btn-sm px-4">Aplicar</button>     
                        <button type="button" class="btn btn-zazz-default rounded-4 shadow-sm btn-sm px-4">Cancelar</button>                      
                      </div>                           
                    </div>
                  </div>                  
                </div>
              </div>
            </div>
            <div class="flex-fill">
              <button class="btn btn-zazz-default rounded-4 px-4 ms-2 shadow-sm" (click)="openFilters()">
                <fa-icon [icon]="icons.faSliders" class="me-2"></fa-icon>
                Filtrar búsqueda
              </button>
            </div>
            <div class="flex-fill">
              <button class="btn btn-zazz-default rounded-4 shadow-sm px-4 ms-2" (click)="openModalPurchaseOrder()">
                <fa-icon [icon]="icons.faPlus" class="me-2"></fa-icon>
                Agregar
              </button>
            </div>
            <div class="flex-fill ms-2">
              <input type="text" class="form-control rounded-4 border border-1 border-secondary" placeholder="Buscar ordenes" formControlName="search">
            </div>
          </div>
          <div class="list-group rounded-5 shadow mt-4" >
            <div class="list-group-item px-4 py-3 border-0">
              <div class="d-flex flex-fill mt-2">
                <div class="btn-group text-center w-100" role="group" aria-label="Filtro recibos">
                  
                </div>
              </div>
            </div>
            <div class="list-group-item w-100" >
              <table class="table table-sm" style="overflow-x: scroll;">
                <thead class="thead-dark">
                  <tr class="">
                    <th scope="col" class="text-start bg-zazz align-middle text-light py-2"># Referencia <button class="btn p-0 text-light"><fa-icon [icon]="icons.faSort"></fa-icon></button></th>
                    <th scope="col" class="text-center bg-zazz align-middle text-light py-2">Proveedor</th>
                    <th scope="col" class="text-center bg-zazz align-middle text-light py-2">Productos</th>
                    <th scope="col" class="text-center bg-zazz align-middle text-light py-2">Status orden</th>
                    <th scope="col" class="text-center bg-zazz align-middle text-light py-2">Fecha creación</th>
                    <th scope="col" class="text-center bg-zazz align-middle text-light py-2">Fecha Estimada</th>
                    <th scope="col" class="text-center bg-zazz align-middle text-light py-2">Total precio</th>
                    <th scope="col" class="text-center bg-zazz align-middle text-light py-2">Responsable</th>
                  </tr>
                </thead>
                <tbody>
                  <tr app-tr-purchase-order
                    [po]="po"
                    [profile]="profile" 
                    [permissions]="permissions"
                    routerLink="/inventory/purchase-orders/{{ po?.id }}"
                    *ngFor="let po of purchaseOrders | paginate: { itemsPerPage: payload.per_page, currentPage: p, totalItems: meta.total_entries }"
                  ></tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-modal-purchase-order></app-modal-purchase-order>
  `,
  styleUrls: []
})
export class IndexPurchaseOrderComponent {
  @ViewChild(ModalPurchaseOrderComponent, { static: true }) modalPurchaseOrderComponent !: ModalPurchaseOrderComponent;
  purchaseOrders: PurchaseOrder[] = [];
  profile: any;
  meta: any = {};
  payload: any = { 
    per_page: 10 ,
    page: 1,

  };
  permissions: any;
  p: any;

  a = new Date();
  fromDate; // : any = "2023/12/01"; // Date = new Date();
  toDate; // : any = "2024/02/02"; // Date = new Date();
  hoveredDate: NgbDate | null = null;

  currentView: string = 'purchaseOrders';

  constructor(
    private invService: InventoryService,
    public icons: IconsService
  ) {
    if (this.a.getMonth() == 0) {
      console.log('IS JANUARY');
      this.fromDate = new NgbDate(this.a.getFullYear() - 1, 12, 1);
    } else {
      this.fromDate = new NgbDate(this.a.getFullYear(), this.a.getMonth(), 1);
    }

    this.toDate = new NgbDate(this.a.getFullYear(), this.a.getMonth()+1, 29);

    this.loadPurchaseOrders();
  }

  loadPurchaseOrders() {
    // Load purchase orders
    this.invService.getPurchaseOrders(this.payload).subscribe((res: any) => {
      console.log('res', res);
      this.purchaseOrders = res.data || [];
      this.meta = res.meta || {};
      // this.meta = res.meta;
    });
  }

  openModalPurchaseOrder(): void {
    // Open modal purchase order
    const modalTemplate: any | undefined = this.modalPurchaseOrderComponent;
    if (modalTemplate) {
      modalTemplate.openModal(modalTemplate['modalPurchaseOrder']);
    }
  }

  openFilters() {}

  onDateSelection(date: NgbDate) {
      console.log("date ====> ", date);
      if (!this.fromDate && !this.toDate) {
        this.fromDate = date;
      } else if (this.fromDate && !this.toDate && date && date.after(this.fromDate)) {
        this.toDate = date;
      } else {
        // this.toDate = null;
        this.fromDate = date;
      }
  
      // this.router.navigate([], {
        // relativeTo: this.route,
        // queryParams: { 
          // "created_at_since": `${this.fromDate.year}-${this.fromDate.month}-${this.fromDate.day}`, 
          // "created_at_to": `${this.toDate?.year}-${this.toDate?.month}-${this.toDate?.day}`
        // },
        // queryParamsHandling: 'merge'
      // });
  
      // this.dateRange.emit({from: this.fromDate, to: this.toDate});
    }
  
    isHovered(date: NgbDate) {
      return this.fromDate;
      // return (
        // this.fromDate && !this.toDate && this.hoveredDate && date.after(this.fromDate) && date.before(this.hoveredDate)
      // );
    }
  
    isInside(date: NgbDate) {
      return this.toDate && date.after(this.fromDate) && date.before(this.toDate);
    }
  
    isRange(date: NgbDate) {
      return (
        date.equals(this.fromDate) ||
        (this.toDate && date.equals(this.toDate)) ||
        this.isInside(date) ||
        this.isHovered(date)
      );
    }
}
